<template>
  <v-layout align-content-start row wrap justify-start class="user-show">
    <v-flex xs12 lg3>
      <section class="section-box">
        <div class="text-xs-center">
          <v-avatar size="128" color="grey lighten-4"
            style="cursor: pointer;" v-modal-trigger="'showEditUser'">
            <img :src="user.avatar" height="128" v-if="user.avatar">
            <v-icon color="grey lighen-4" v-else>fal fa-camera</v-icon>
          </v-avatar>
          <h2>{{ user.first_name }}</h2>
          <v-btn flat small color="blue-grey lighten-2" v-modal-trigger="'showEditUser'">
            <v-icon small left>fal fa-edit</v-icon> Editar
          </v-btn>
          <v-btn flat small color="red lighten-2" @click.stop="deleteConfirm = true">
            <v-icon small left>fal fa-trash-alt</v-icon> Excluir
          </v-btn>
          <v-divider></v-divider>
          <v-list two-line>
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon small color="deep-orange darken-2">fal fa-envelope</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Email</v-list-tile-title>
                <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-if="user.phones">
              <v-list-tile-avatar>
                <v-icon small color="deep-orange darken-2">fal fa-phone</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Telefone</v-list-tile-title>
                <v-list-tile-sub-title>{{ user.phones[0] }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon small color="deep-orange darken-2">fal fa-circle</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Status</v-list-tile-title>
                <v-list-tile-sub-title style="max-width: 140px; padding-right: 10px;">
                  <user-status-label :status="user.status"></user-status-label>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon small color="deep-orange darken-2">fal fa-check</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Plano</v-list-tile-title>
                <v-list-tile-sub-title>
                  <user-plan-label :plan="user.plan"></user-plan-label>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon small color="deep-orange darken-2">fal fa-calendar</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Data do cadastro</v-list-tile-title>
                <v-list-tile-sub-title>
                  <v-tooltip bottom>
                    <span slot="activator">{{ user.created_at | moment('from', 'now') }}</span>
                    <span>{{ user.created_at | moment('DD/MM/Y, HH:mm') }}</span>
                  </v-tooltip>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </div>
        <user-more-information :user="user" :address="address"></user-more-information>
      </section>
    </v-flex>
    <v-flex xs12 lg9>
      <v-tabs slider-color="deep-orange darken-2" fixed-tabs>
        <v-tab href="#tab-1">Acompanhamento</v-tab>
        <v-tab href="#tab-2">Treinos</v-tab>
        <v-tab href="#tab-3">Avaliações</v-tab>
        <v-tab href="#tab-4">Financeiro</v-tab>
        <v-tab-item id="tab-1">
          <user-show-notes></user-show-notes>
        </v-tab-item>
        <v-tab-item id="tab-2">
          <user-training :user="user"></user-training>
        </v-tab-item>
        <v-tab-item id="tab-3">
          <user-evaluations :user="user"></user-evaluations>
        </v-tab-item>
        <v-tab-item id="tab-4">
          <admin-user-show-financial v-if="user && user._id" :user="user"></admin-user-show-financial>
        </v-tab-item>
      </v-tabs>
    </v-flex>
    <new-notification></new-notification>
    <admin-user-show-edit></admin-user-show-edit>

    <v-dialog v-model="deleteConfirm" persistent max-width="400"
      @keydown.esc="deleteConfirm = false">
      <v-card>
        <v-toolbar dark color="red lighten-1">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">Deseja excluir o usuário?</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.stop="deleteConfirm = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <br>
        <v-card-actions class="text-xs-center">
          <v-spacer></v-spacer>
          <v-btn flat @click.native="deleteConfirm = false">
            Cancelar
          </v-btn>
          <v-btn color="red darken-1" outline
            @click.native="deleteUser" :loading="deleteLoading">
            Excluir usuário
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import router from '@/router'
import AdminUserShowNotes from '@/components/admin/userShow/AdminUserShowNotes'
import AdminUserShowEvaluations from '@/components/admin/userShow/AdminUserShowEvaluations'
import AdminUserShowTraining from '@/components/admin/userShow/AdminUserShowTraining'
import AdminUserShowEdit from '@/components/admin/userShow/AdminUserShowEdit'
import AdminUserShowFinancial from '@/components/admin/userShow/AdminUserShowFinancial'
import UserStatusLabel from '@/modules/UserStatusLabel'
import UserPlanLabel from '@/modules/UserPlanLabel'
import UserMoreInformations from '@/components/user/UserMoreInformations'
import EventBus from '@/event-bus'
import AdminNotificationsNew from '@/components/admin/notifications/AdminNotificationsNew'

export default {
  name: 'AdminUserShow',

  data: () => ({
    user: {},
    deleteLoading: false,
    deleteConfirm: false,
    showMoreInfo: false,
    address: {}
  }),

  methods: {
    loadAddress () {
      // eslint-disable-next-line
      axios.get(`${API.userAddresses}/users/${this.user._id}`).then(response => {
        if (response.data.address) {
          this.address = response.data.address
        } else {
          this.address = {}
        }
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Ocorreu um erro ao carregar o endereço',
          color: 'error'
        })
      })
    },

    toggleMoreInfo () {
      this.showMoreInfo = !this.showMoreInfo
    },

    loadUser () {
      EventBus.$emit('appLoading', true)

      // eslint-disable-next-line
      axios.get(`${API.users}/${this.$route.params.id}`).then(response => {
        this.user = response.data.user
        EventBus.$emit('appLoading', false)
        this.loadAddress()
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao carregar o usuário',
          color: 'error'
        })
        EventBus.$emit('appLoading', false)
      })
    },

    deleteUser () {
      this.deleteLoading = true

      // eslint-disable-next-line
      axios.delete(API.users + '/' + this.$route.params.id).then(response => {
        this.deleteConfirm = false
        router.push({ name: 'AdminUsers' })
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Erro ao deletar o usuário',
          color: 'error'
        })
        this.deleteLoading = false
      })
    }
  },

  created () {
    this.loadUser()
    EventBus.$on('loadUser', () => {
      this.loadUser()
    })
  },

  components: {
    'user-status-label': UserStatusLabel,
    'user-plan-label': UserPlanLabel,
    'user-show-notes': AdminUserShowNotes,
    'user-evaluations': AdminUserShowEvaluations,
    'user-more-information': UserMoreInformations,
    'user-training': AdminUserShowTraining,
    'new-notification': AdminNotificationsNew,
    AdminUserShowEdit,
    AdminUserShowFinancial
  }
}
</script>

<style>
.user-show .v-tabs__bar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}

.v-expansion-panel {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminUserShow.vue